import Vue from "vue"
import VueRouter from "vue-router"

import Dashboard from "./pages/Dashboards/Dashboard.vue"
import InvStock from "./pages/Inventory/Stock"
import InvForm from "./pages/Inventory/Form"
import InvIssue from "./pages/Inventory/Issue"
import InvIssuePtint from "./pages/Inventory/IssuePrint"
import InvTransfer from "./pages/Inventory/Transfer"
import InvTransferPrint from "./pages/Inventory/TransferPrint"
import InvDefective from "./pages/Inventory/Defective"
import InvDefectiveToner from "./pages/Inventory/DefectiveToner"
import InvDefectiveTonerPrint from "./pages/Inventory/DefectiveTonerPrint.vue"
import InvClaim from "./pages/Inventory/Claim"
import InvSameitem from "./pages/Inventory/Sameitem"
import InvSameitemAdd from "./pages/Inventory/SameitemAdd"
import InvSameitemPrint from "./pages/Inventory/SameitemPrint.vue"
import InvStockin from "./pages/Inventory/StockIn.vue"
import InvStockinEdit from "./pages/Inventory/StockIn_Edit.vue"
import InvStockinDetail from "./pages/Inventory/Stock_Detail.vue"
import InvStockinAdd from "./pages/Inventory/StockIn_Add.vue"
import InvStockBarcode from "./pages/Inventory/Barcode"
import InvViewStock from "./pages/Inventory/ViewStock"
import ClaimODM from "./pages/Inventory/ClaimODM"
import ReportsInv from "./pages/Inventory/Reports.vue"
import InvNorm from "./pages/Inventory/Norm.vue"
import InvSetting from "./pages/Inventory/Setting.vue"

import SettingProject from "./pages/Setting/Project"
import SettingSupplier from "./pages/Setting/Supplier"
import SettingBranch from "./pages/Setting/Branch"
import SettingCategory from "./pages/Setting/Category.vue"
import SettingPartner from "./pages/Setting/Partner.vue"
import SRFR_Product from "./pages/Setting/SRFR_Product.vue"
import Setting from "./pages/Setting/Setting.vue"
import SettingAnnounce from "./pages/Setting/Announce.vue"
import Knowledge from "./pages/Setting/Knowledge.vue"
import ProjectCase from "./pages/Project/Nonhp/Case.vue"
import ProjectEditCase from "./pages/Project/Nonhp/EditCase.vue"
import ProjectSubCase from "./pages/Project/Nonhp/SubCase.vue"
import ViewCasepending from "./pages/Project/components/ViewCasepending.vue"
import PendingCase from "./pages/Project/components/PendingCase.vue"
import NonHpCloseCase from "./pages/Project/components/CloseCase.vue"
import TableCaseProject from "./pages/Project/Nonhp/TableCaseProject.vue"
import DocNonhp from "./pages/Project/Nonhp/DocNonhp.vue"

import UcCase from "./pages/Project/Uc/Case.vue"
import UcSubCase from "./pages/Project/Uc/SubCase.vue"
import PendingCaseUC from "./pages/Project/components/PendingCase.vue"
import UcEditCase from "./pages/Project/Uc/EditCase.vue"
import UcCloseCase from "./pages/Project/components/CloseCase.vue"
import CtrPart from "./pages/Project/Uc/CtrPart.vue"

import OdmCase from "./pages/Project/Odm/Case.vue"
import OdmSubCase from "./pages/Project/Odm/SubCase.vue"
import PendingCaseOdm from "./pages/Project/components/PendingCase.vue"
import OdmEditCase from "./pages/Project/Odm/EditCase.vue"
import OdmDoc from "./pages/Project/Odm/Document.vue"
import OdmCloseCase from "./pages/Project/components/CloseCase.vue"
import OdmOnsiteCase from "./pages/Project/Odm/CaseOnsite.vue"

import BkkCase from "./pages/Project/Bkk/Case.vue"
import PendingCaseBkk from "./pages/Project/components/PendingCase.vue"
import BkkSubCase from "./pages/Project/Bkk/SubCase.vue"
import BkkEditCase from "./pages/Project/Bkk/EditCase.vue"
import BKkOnsiteCase from "./pages/Project/Bkk/CaseOnsite.vue"
import BkkCloseCase from "./pages/Project/components/CloseCase.vue"

import SvcCase from "./pages/Project/Svc/Case.vue"
import PendingCaseSvc from "./pages/Project/components/PendingCase.vue"
import SvcEditCase from "./pages/Project/Svc/EditCase.vue"
import SvcSubCase from "./pages/Project/Svc/SubCase.vue"
import SvcCloseCase from "./pages/Project/components/CloseCase.vue"

import BenchCase from "./pages/Project/Bench/Case.vue"
import PendingCaseBench from "./pages/Project/components/PendingCase.vue"
import BenchCloseCase from "./pages/Project/components/CloseCase.vue"
import BenchEditCase from "./pages/Project/Bench/EditCase.vue"
import BenchSubCase from "./pages/Project/Bench/SubCase.vue"
import BenchOnsite from "./pages/Project/Bench/Onsite.vue"
import BenchCeCloseCase from "./pages/Project/Bench/CeCloseCase.vue"

import OkiCase from "./pages/Project/Oki/Case.vue"
import OkiEditCase from "./pages/Project/Oki/EditCase.vue"
import OkiSubCase from "./pages/Project/Oki/SubCase.vue"
import PendingCaseOki from "./pages/Project/components/PendingCase.vue"
import OkiCloseCase from "./pages/Project/components/CloseCase.vue"

import PermissionUsers from "./pages/Permission/Users.vue"
import PermissionMenu from "./pages/Permission/Menu.vue"
import PermissionMenuAdd from "./pages/Permission/Menu_Add.vue"
import PermissionTeam from "./pages/Permission/Team.vue"
import PermissionTeamAdd from "./pages/Permission/Team_Add.vue"
import PermissionStatus from "./pages/Permission/Status.vue"
import PermissionManage from "./pages/Permission/Permissions.vue"
import PermissionManageRole from "./pages/Permission/Permissions_Role.vue"
import PermissionManageMainMenu from "./pages/Permission/Permissions_MainMenu.vue"
import PermissionManageSubMenu from "./pages/Permission/Permissions_SubMenu.vue"
import PermissionManageMember from "./pages/Permission/Permissions_Member.vue"
import ForgotPassword from "./components/Login.vue"
import Login from "./components/Login.vue"
import ItserviceIndex from "./pages/Itservice/Index.vue"
import ItserviceHr from "./pages/Itservice/Hr.vue"
import ItserviceDoc from "./pages/Itservice/Doc.vue"
import ItserviceDoc1 from "./pages/Itservice/Doc1.vue"
import ItserviceReport from "./pages/Itservice/Report.vue"
import ItserviceRequestForm from "./pages/Itservice/RequestForm.vue"
import ItMonitorGPS from "./pages/Itservice/MonitorGPS.vue"
import ItMonitorGGM from "./pages/Itservice/MonitorGGM.vue"
import ItRunCaseNumber from "./pages/Itservice/RunCaseNumber.vue"
import KciIndex from "./pages/Project/kci/Index.vue"
import HpcIndex from "./pages/Project/hpc/Index.vue"
import Hpcsearch from "./pages/Project/hpc/testsearch.vue"
import HpcReport from "./pages/Project/hpc/report.vue"
import CeUpdate from "./pages/Project/components/CeUpdate.vue"

import LogisticViewOwner from "./pages/Logistic/Viewowner.vue"
import LogisticPackinglist from "./pages/Logistic/Packinglist.vue"
import LogisticDocLogistic from "./pages/Logistic/DocLogistic.vue"

import MainOnsite from "./pages/Onsite/Main.vue"
import OnsitePending from "./pages/Onsite/components/OnsitePending.vue"

import KbankBKK from "./pages/Onsite/components/Onsite.vue"

import Document from "./pages/Document/Document.vue"
import DocumentEngineer from "./pages/Document/DocEngineer.vue"

import DocumentUnused from "./pages/Document/DocUNUSEDPARTS.vue"
import DocDOA from "./pages/Document/DocDOA.vue"

import Chart from "./pages/Document/Chart.vue"

import ReturnDocumentPrint from "./pages/Onsite/components/ReturnDocumentPrint.vue"
import DocumentReturn from "./pages/Document/DocReturn.vue"
import DocumentReturnNonhp from "./pages/Document/DocReturnNonhp.vue"

import ExpenseMileage from "./pages/Expense/Mileage.vue"
import ExpenseMileageTL from "./pages/Expense/MileageTL.vue"
import ExpenseMileageApprove from "./pages/Expense/MileageApprove.vue"
import ExpensePendingApproved from "./pages/Expense/PendingApproved.vue"

import PmInstallIndex from "./pages/Project/PmInstall/Index.vue"
import PmInstallDashboard from "./pages/Project/PmInstall/Dashboard.vue"

import ReceivePart from "./pages/Onsite/components/ReceivePart.vue"
import ReturnPart from "./pages/Onsite/components/ReturnPart.vue"
import Signature from "./pages/Onsite/components/Signature.vue"

import BenchRama3 from "./pages/Project/components/BenchRama3.vue"
import HpPart from "./pages/Project/HpPart/index.vue"

import UEFI from "./pages/uefi/index.vue"

import DashboardEngineer from "./pages/Dashboards/DashboardEngineer.vue"

import Report from "./pages/Reports/index.vue"

import SearchCase from "./components/system/searchCase.vue"
import PermissionDenied from "./components/system/404.vue"

import SearchInv from "./pages/Inventory/components/Search.vue"
import GoogleMap from "./test/TravelMap.vue"

import LuckyDay from "./test/seminar/index.vue"
// Test Address
import TestAdd from "./test/TestAdd.vue"
import TestAdd2 from "./test/TestAdd2.vue"

import InvCase from "./pages/Project/Inventory/Case.vue"

import OTtl from "./pages/OT/index.vue"
import OTApprove from "./pages/OT/Approve.vue"

import timeatt from "./components/TimeAttendance.vue"
import SearchCso from "./pages/Onsite/components/SearchCso.vue"
import Tracking from "./components/Tracking.vue"

// import timeatt from "./components/TimeAttendance_Backup.vue"

import DocLcdMb from "./pages/Document/DocLcdMb.vue"

import TestDashboards from "./test/Dashboards/index.vue"

//HR
import Employee from "./pages/HR/SettingEmployee.vue"
import TimeAttReport from "./pages/HR/TimeAttReport.vue"

import SurveyCovid from "./pages/HR/Covid/Survey.vue"
import SurveyReport from "./pages/HR/Covid/Report.vue"

import Change from "./pages/ChangeRequest/Index.vue"
import Ismart from "./pages/Project/All/Ismart.vue"
import PoPending from "./pages/Project/All/PoPending.vue"

// Scrap
import Scrap from "./pages/Project/Scrap/Index.vue"

// Posnet
import PrintPosnet from "./pages/Project/Print/Posnet.vue"
import PosnetData from "./pages/Project/Posnet/index.vue"

import HealthCheckSetting from "./pages/HealthCheck/Setting.vue"
import HealthCheck from "./pages/HealthCheck/HealthCheck.vue"

Vue.use(VueRouter)

const routes = [{
        path: "/",
        // component: InvStock,
        meta: {
            title: "Hybrid System.",
        },
    },
    {
        path: "/Project/Scrap/",
        component: Scrap,
        meta: {
            title: "Scrap",
        },
    },
    {
        path: "/Dashboard",
        component: Dashboard,
        meta: {
            title: "Dashboard",
            requireAuth: true,
        },
    },

    {
        path: "/Inventory/Stock/",
        component: InvStock,
        meta: {
            title: "Inventory - Stock",
            // requireAuth: true,
        },
    },
    {
        path: "/Inventory/Stock/:pages",
        component: InvStock,
        meta: {
            title: "Inventory - Stock",
        },
    },
    {
        path: "/Inventory/Form",
        component: InvForm,
        meta: {
            title: "Inventory - Form Issue / Transfer",
        },
    },
    {
        path: "/Inventory/Issue",
        component: InvIssue,
        meta: {
            title: "Inventory - Issue",
        },
    },
    {
        path: "/Inventory/Issue-Print/:maincase_id/:subcase",
        component: InvIssuePtint,
        meta: {
            title: "Inventory - Issue-Print",
        },
    },
    {
        path: "/Inventory/Transfer",
        component: InvTransfer,
        meta: {
            title: "Inventory - Transfer",
        },
    },
    {
        path: "/Inventory/Transfer-Print/:transfer_id",
        component: InvTransferPrint,
        meta: {
            title: "Inventory - Transfer Print",
        },
    },
    {
        path: "/Inventory/Defective",
        component: InvDefective,
        meta: {
            title: "Inventory - Defective",
        },
    },
    {
        path: "/Inventory/Defective-Toner",
        component: InvDefectiveToner,
        meta: {
            title: "Inventory - Defective Toner",
        },
    },
    {
        path: "/Inventory/Defective-Toner/Print/:transfer_id",
        component: InvDefectiveTonerPrint,
        meta: {
            title: "Inventory - Defective Toner Print",
        },
    },
    {
        path: "/Inventory/On-Claim",
        component: InvClaim,
        meta: {
            title: "Inventory - On Claim",
        },
    },
    {
        path: "/Inventory/Same-Item",
        component: InvSameitem,
        meta: {
            title: "Inventory - Same Item",
        },
    },
    {
        path: "/Inventory/Same-Item-Add",
        component: InvSameitemAdd,
        meta: {
            title: "Inventory - Same Item",
        },
    },
    {
        path: "/Inventory/Same-Item/:sameitem_id",
        component: InvSameitemPrint,
        meta: {
            title: "Inventory - Same Item Print",
        },
    },
    {
        path: "/Inventory/Stock-In/:pages",
        component: InvStockin,
        meta: {
            title: "Inventory - Stock In",
        },
    },
    {
        path: "/Inventory/Stock-In/:pages/:id",
        component: InvStockinEdit,
        meta: {
            title: "Inventory - Stock In",
        },
    },
    {
        path: "/Inventory/Stock-Detail/:type/:pages/:id",
        component: InvStockinDetail,
        meta: {
            title: "Inventory - Stock Detail",
        },
        // query: {
        //     branch_id: "",
        //     category_id: "",
        //     project_id: "",
        //     search: "",
        // },
        // props: true,
    },
    {
        path: "/Inventory/Stock-Detail/:type/:pages/:id/:branch",
        component: InvStockinDetail,
        meta: {
            title: "Inventory - Stock Detail",
        },
    },
    {
        path: "/Inventory/Stock-In/Part/:pages/:id",
        component: InvStockinAdd,
        meta: {
            title: "Inventory - Stock In Part",
        },
    },
    {
        path: "/Inventory/Stock-In/Barcode/:pages/:id",
        component: InvStockBarcode,
        meta: {
            title: "Inventory - Print Barcode",
        },
    },
    {
        path: "/Inventory/View-Stock",
        component: InvViewStock,
        meta: {
            title: "Inventory - View Stock",
        },
    },
    {
        path: "/Inventory/SRFR/Claim",
        component: ClaimODM,
        meta: {
            title: "Inventory - SRFR Claim",
        },
    },
    {
        path: "/Health-Check/Setting",
        component: HealthCheckSetting,
        meta: {
            title: "Setting - IT Health Check",
        },
    },
    {
        path: "/Health-Check",
        component: HealthCheck,
        meta: {
            title: "Setting - IT Health Check",
        },
    },
    {
        path: "/Setting/Project",
        component: SettingProject,
        meta: {
            title: "Setting - Project",
        },
    },
    {
        path: "/Setting/Supplier",
        component: SettingSupplier,
        meta: {
            title: "Setting - Supplier",
        },
    },
    {
        path: "/Setting/Branch",
        component: SettingBranch,
        meta: {
            title: "Setting - Branch",
        },
    },
    {
        path: "/Setting/Category",
        component: SettingCategory,
        meta: {
            title: "Setting - Category",
        },
    },
    {
        path: "/Setting/Partner",
        component: SettingPartner,
        meta: {
            title: "Setting - Partner",
        },
    },
    {
        path: "/Setting/SRFR-Product",
        component: SRFR_Product,
        meta: {
            title: "Setting - SRFR Product",
        },
    },

    {
        path: "/Setting",
        component: Setting,
        meta: {
            title: "Setting",
        },
    },
    {
        path: "/Setting/Announce",
        component: SettingAnnounce,
        meta: {
            title: "Setting - Announce",
        },
    },
    {
        path: "/Setting/Knowledge",
        component: Knowledge,
        meta: {
            title: "Knowledge",
        },
    },
    {
        path: "/Project/Nonhp/Case",
        component: ProjectCase,
        meta: {
            title: "View All Cases",
        },
    },
    {
        path: "/Project/Nonhp/EditCase/:caseid/:subcase",
        component: ProjectEditCase,
        meta: {
            title: "Edit Case",
        },
    },
    {
        path: "/Project/Nonhp/SubCase/:caseid",
        component: ProjectSubCase,
        meta: {
            title: "Open New Sub",
        },
    },
    {
        path: "/Project/Nonhp/PendingCase/:team",
        component: PendingCase,
        meta: {
            title: "Pending Case",
        },
    },
    {
        path: "/Project/Nonhp/CloseCase",
        component: NonHpCloseCase,
        meta: {
            title: "Close Case",
        },
    },
    {
        path: "/Project/Nonhp/CaseProject",
        component: TableCaseProject,
        meta: {
            title: "Case Project",
        },
    },

    {
        path: "/Project/ViewCasepending/:team/:caseid/:status",
        component: ViewCasepending,
        meta: {
            title: "View Case Pending",
        },
    },
    {
        path: "/Project/Uc/Case",
        component: UcCase,
        meta: {
            title: "View All Cases",
        },
    },
    {
        path: "/Project/Uc/SubCase/:caseid",
        component: UcSubCase,
        meta: {
            title: "Open New Sub",
        },
    },
    {
        path: "/Project/Uc/EditCase/:caseid/:subcase",
        component: UcEditCase,
        meta: {
            title: "Edit Case",
        },
    },
    {
        path: "/Project/Uc/PendingCase/:team",
        component: PendingCaseUC,
        meta: {
            title: "Pending Case",
        },
    },
    {
        path: "/Project/Uc/CloseCase",
        component: UcCloseCase,
        meta: {
            title: "Close Case",
        },
    },
    {
        path: "/Project/Uc/CTR-Part",
        component: CtrPart,
        meta: {
            title: "UC - CTR Part",
        },
    },

    {
        path: "/Permission/Users",
        component: PermissionUsers,
        meta: {
            title: "Permission - Users",
        },
    },
    {
        path: "/Permission/Menu",
        component: PermissionMenu,
        meta: {
            title: "Permission - Menu",
        },
    },
    {
        path: "/Permission/Menu-Add",
        component: PermissionMenuAdd,
        meta: {
            title: "Permission - Menu Add",
        },
    },
    {
        path: "/Permission/Menu-Add/:id",
        component: PermissionMenuAdd,
        meta: {
            title: "Permission - Menu Add",
        },
    },
    {
        path: "/Permission/Team",
        component: PermissionTeam,
        meta: {
            title: "Permission - Team",
        },
    },
    {
        path: "/Permission/Team-Add",
        component: PermissionTeamAdd,
        meta: {
            title: "Permission - Team Add",
        },
    },
    {
        path: "/Permission/Team-Add/:id",
        component: PermissionTeamAdd,
        meta: {
            title: "Permission - Team Add",
        },
    },
    {
        path: "/Permission/Status",
        component: PermissionStatus,
        meta: {
            title: "Permission - Status",
        },
    },
    {
        path: "/Permission/Manage",
        component: PermissionManage,
        meta: {
            title: "Permission - Manage",
        },
    },
    {
        path: "/Permission/Manage/:team_id",
        component: PermissionManageRole,
        meta: {
            title: "Permission - Manage",
        },
    },
    {
        path: "/Permission/Manage/:team_id/:role_id",
        component: PermissionManageMainMenu,
        meta: {
            title: "Permission - Manage",
        },
    },
    {
        path: "/Permission/Manage/:team_id/:role_id/:menu_id",
        component: PermissionManageSubMenu,
        meta: {
            title: "Permission - Manage",
        },
    },
    {
        path: "/Permission/Manage/:team_id/:role_id/:menu_id/:submenu_id",
        component: PermissionManageMember,
        meta: {
            title: "Permission - Manage",
        },
    },
    {
        path: "/resetpass/:token",
        component: ForgotPassword,
        meta: {
            title: "Permission - Reset Password",
        },
    },
    {
        path: "/Itservice/Index",
        component: ItserviceIndex,
        meta: {
            title: "IT Services",
        },
    },
    {
        path: "/Itservice/Hr",
        component: ItserviceHr,
        meta: {
            title: "HR",
        },
    },
    {
        path: "/Itservice/Doc",
        component: ItserviceDoc,
        meta: {
            title: "Doc",
        },
    },
    {
        path: "/Itservice/Doc1",
        component: ItserviceDoc1,
        meta: {
            title: "Doc1",
        },
    },
    {
        path: "/Itservice/Report",
        component: ItserviceReport,
        meta: {
            title: "Report Itservice",
        },
    },
    {
        path: "/Itservice/RequestForm",
        component: ItserviceRequestForm,
        meta: {
            title: "RequestForm",
        },
    },
    {
        path: "/Itservice/Monitor-GPS",
        component: ItMonitorGPS,
        meta: {
            title: "Monitor GPS",
        },
    },
    {
        path: "/Itservice/ggm",
        component: ItMonitorGGM,
        meta: {
            title: "Monitor GGM",
        },
    },
    {
        path: "/Itservice/Run-Case-Number",
        component: ItRunCaseNumber,
        meta: {
            title: "Monitor GPS",
        },
    },
    // {
    //     path: "/Itservice/RunCaseNumber",
    //     component: ItRunCaseNumber,
    //     meta: {
    //         title: "Run Case Number",
    //     },
    // },
    {
        path: "/Test",
        component: GoogleMap,
    },
    // {
    //     path: "/TestAdd",
    //     component: TestAdd,
    // },
    // {
    //     path: "/TestAdd2",
    //     component: TestAdd2,
    // },
    {
        path: "/Project/kci/index",
        component: KciIndex,
        meta: {
            title: "Admin Informed",
        },
    },
    {
        path: "/Project/hpc/index",
        component: HpcIndex,
        meta: {
            title: "Happy Call",
        },
    },
    {
        path: "/Project/hpc/report",
        component: HpcReport,
        meta: {
            title: "Happy Call Report",
        },
    },
    {
        path: "/Project/hpc/testsearch",
        component: Hpcsearch,
        meta: {
            title: "Happy Call",
        },
    },
    {
        path: "/Onsite/Main",
        component: MainOnsite,
        meta: {
            title: "Onsite Services",
        },
    },
    {
        path: "/Onsite/Pending",
        component: OnsitePending,
        meta: {
            title: "Onsite Pending",
        },
    },

    {
        path: "/Kbank-BKK",
        component: KbankBKK,
        meta: {
            title: "Kbank BKK",
        },
    },

    {
        path: "/Document",
        component: Document,
        meta: {
            title: "Document",
        },
    },
    {
        path: "/Document/DocEngineer",
        component: DocumentEngineer,
        meta: {
            title: "Return Document",
        },
    },
    {
        path: "/Document/DocReturn-hp/:return_no",
        component: DocumentReturn,
        meta: {
            title: "Document HP",
        },
    },
    {
        path: "/Document/DocReturn-nonhp/:return_no",
        component: DocumentReturnNonhp,
        meta: {
            title: "Document NONHP",
        },
    },
    {
        path: "/Document/DocUnused/:part_issue_id",
        component: DocumentUnused,
        meta: {
            title: "Document",
        },
    },
    {
        path: "/Document/DocDOA/:part_issue_id",
        component: DocDOA,
        meta: {
            title: "Document",
        },
    },
    {
        path: "/Project/Odm/EditCase/:caseid/:subcase",
        component: OdmEditCase,
        meta: {
            title: "Edit Case",
        },
    },
    {
        path: "/Chart",
        component: Chart,
        meta: {
            title: "Chart",
        },
    },
    {
        path: "/Logistic/Viewowner",
        component: LogisticViewOwner,
        meta: {
            title: "Logistics",
        },
    },
    {
        path: "/Logistic/Packinglist",
        component: LogisticPackinglist,
        meta: {
            title: "Logistics Packinglist",
        },
    },
    {
        path: "/Logistic/DocLogistic/:packingno/:company",
        component: LogisticDocLogistic,
        meta: {
            title: "Logistics Print",
        },
    },
    {
        path: "/Project/Odm/Case",
        component: OdmCase,
        meta: {
            title: "View All Cases",
        },
    },
    {
        path: "/Project/Odm/PendingCase/:team",
        component: PendingCaseOdm,
        meta: {
            title: "Pending Case",
        },
    },
    {
        path: "/Project/PrintODM/:caseid/:subcaseid",
        component: OdmDoc,
        meta: {
            title: "ODM Print",
        },
    },
    {
        path: "/Project/Odm/SubCase/:caseid",
        component: OdmSubCase,
        meta: {
            title: "Open New Sub",
        },
    },
    {
        path: "/Project/Odm/CloseCase",
        component: OdmCloseCase,
        meta: {
            title: "Close Case",
        },
    },
    {
        path: "/Project/Bkk/Case",
        component: BkkCase,
        meta: {
            title: "View All Cases",
        },
    },
    {
        path: "/Project/Bkk/SubCase/:caseid",
        component: BkkSubCase,
        meta: {
            title: "Open New Sub",
        },
    },
    {
        path: "/Project/Bkk/PendingCase/:team",
        component: PendingCaseBkk,
        meta: {
            title: "Pending Case",
        },
    },
    {
        path: "/Project/Bkk/EditCase/:caseid/:subcase",
        component: BkkEditCase,
        meta: {
            title: "Edit Case",
        },
    },
    {
        path: "/Project/Bkk/CaseOnsite",
        component: BKkOnsiteCase,
        meta: {
            title: "Onsite Today",
        },
    },
    {
        path: "/Project/Bkk/CloseCase",
        component: BkkCloseCase,
        meta: {
            title: "Close Case",
        },
    },
    {
        path: "/Project/Svc/Case",
        component: SvcCase,
        meta: {
            title: "View All Cases",
        },
    },
    {
        path: "/Project/Svc/PendingCase/:team",
        component: PendingCaseSvc,
        meta: {
            title: "Pending Case",
        },
    },
    {
        path: "/Project/Svc/SubCase/:caseid",
        component: SvcSubCase,
        meta: {
            title: "Open New Sub",
        },
    },
    {
        path: "/Project/Svc/EditCase/:caseid/:subcase",
        component: SvcEditCase,
        meta: {
            title: "Edit Case",
        },
    },
    {
        path: "/Project/Svc/CloseCase",
        component: SvcCloseCase,
        meta: {
            title: "Close Case",
        },
    },
    {
        path: "/Onsite/Main/Print-ReturnDocument/:doc_no/:status",
        component: ReturnDocumentPrint,
        meta: {
            title: "Print Return Document",
        },
    },
    {
        path: "/Onsite/Main/:menu",
        component: MainOnsite,
        meta: {
            title: "Onsite Services",
        },
    },
    {
        path: "/Project/Odm/CaseOnsite",
        component: OdmOnsiteCase,
        meta: {
            title: "View All Cases",
        },
    },
    {
        path: "/Expense/Mileage",
        component: ExpenseMileage,
        meta: {
            title: "Expense - Mileage",
            allowAnonymous: true,
        },
    },
    {
        path: "/Expense/Mileage/Tl/:type_status",
        component: ExpenseMileageTL,
        meta: {
            title: "Expense - Mileage",
        },
    },
    {
        path: "/Expense/Mileage/:emp_id/:type_status",
        component: ExpenseMileageTL,
        meta: {
            title: "Expense - Mileage",
        },
    },
    {
        path: "/Expense/Mileage/Tl/:type_status/:emp_id",
        component: ExpenseMileageApprove,
        meta: {
            title: "Expense - Mileage",
        },
    },

    {
        path: "/Expense/Pending-Approved",
        component: ExpensePendingApproved,
        meta: {
            title: "Expense - Pending Approved",
        },
    },
    {
        path: "/Project/PmInstall/:project",
        component: PmInstallIndex,
        meta: {
            title: "PM/Install",
        },
    },
    {
        path: "/Project/PmInstall/Dashboard/:project/:subproject/:groupid",
        component: PmInstallDashboard,
        meta: {
            title: "PM/Install Dashboard",
        },
    },
    {
        path: "/Receive-Part/",
        component: ReceivePart,
        meta: {
            title: "Receive Part",
        },
    },
    {
        path: "/Return-Part",
        component: ReturnPart,
        meta: {
            title: "Return Part",
        },
    },
    {
        path: "/DEMO01",
        component: Signature,
        meta: {
            title: "Signature",
        },
    },

    {
        path: "/Project/Ce-Update",
        component: CeUpdate,
        meta: {
            title: "Engineer Update",
        },
    },
    {
        path: "/Project/Bench-Rama3",
        component: BenchRama3,
        meta: {
            title: "Bench Rama3",
        },
    },
    {
        path: "/Project/Bench/Case",
        component: BenchCase,
        meta: {
            title: "View All Cases",
        },
    },
    {
        path: "/Project/Bench/PendingCase/:team",
        component: PendingCaseBench,
        meta: {
            title: "Pending Case",
        },
    },
    {
        path: "/Project/Bench/CloseCase",
        component: BenchCloseCase,
        meta: {
            title: "Close Case",
        },
    },
    {
        path: "/Project/Bench/EditCase/:caseid/:subcase",
        component: BenchEditCase,
        meta: {
            title: "Edit Case",
        },
    },
    {
        path: "/Project/Bench/SubCase/:caseid",
        component: BenchSubCase,
        meta: {
            title: "Open New Sub",
        },
    },
    {
        path: "/Project/Bench/Onsite",
        component: BenchOnsite,
        meta: {
            title: "Onsite Bench",
        },
    },
    {
        path: "/Project/Oki/Case",
        component: OkiCase,
        meta: {
            title: "Open Case",
        },
    },
    {
        path: "/Project/Oki/EditCase/:caseid/:subcase",
        component: OkiEditCase,
        meta: {
            title: "Edit Case",
        },
    },
    {
        path: "/Project/Oki/SubCase/:caseid",
        component: OkiSubCase,
        meta: {
            title: "Open New Sub",
        },
    },
    {
        path: "/Project/Oki/PendingCase/:team",
        component: PendingCaseOki,
        meta: {
            title: "Pending Case",
        },
    },
    {
        path: "/Project/Oki/CloseCase",
        component: OkiCloseCase,
        meta: {
            title: "Close Case",
        },
    },
    {
        path: "/Project/Bench/Onsite/CloseCase/:maincase_id",
        component: BenchCeCloseCase,
        meta: {
            title: "Onsite Bench - Close Case",
        },
    },
    {
        path: "/uefi",
        component: UEFI,
        meta: {
            title: "UEFI",
        },
    },
    {
        path: "/Hp-Part",
        component: HpPart,
        meta: {
            title: "HP - Part",
        },
    },
    {
        path: "/Dashboard/Engineer",
        component: DashboardEngineer,
        meta: {
            title: "Dashboard - Engineer",
        },
    },
    {
        path: "/Reports",
        component: Report,
        meta: {
            title: "Report",
        },
    },
    {
        path: "/Inventory/Reports",
        component: ReportsInv,
        meta: {
            title: "Export Report",
        },
    },
    {
        path: "/Inventory/Norm",
        component: InvNorm,
        meta: {
            title: "Norm",
        },
    },
    {
        path: "/Inventory/Setting",
        component: InvSetting,
        meta: {
            title: "Inventory - Setting",
        },
    },

    {
        path: "/Search-Case/:search",
        component: SearchCase,
        meta: {
            title: "Search Case",
        },
    },
    {
        path: "/Search-Parts",
        component: SearchInv,
        meta: {
            title: "Search Part",
        },
    },
    {
        path: "/404",
        component: PermissionDenied,
        meta: {
            title: "Permission Denied",
        },
    },

    {
        name: "Login",
        path: "/Login",
        component: Login,
        meta: {
            title: "Login ",
        },
    },
    {
        path: "/Project/Inventory/Case",
        component: InvCase,
        meta: {
            title: "Inventory Opencase",
        },
    },
    {
        path: "/OT",
        component: OTtl,
        meta: {
            title: "OT",
        },
    },
    {
        path: "/OT/:emp_id",
        component: OTApprove,
        meta: {
            title: "OT",
        },
    },
    {
        name: "TimeAtt",
        path: "/TimeAtt",
        component: timeatt,
        meta: {
            title: "Time Attendance",
        },
    },
    {
        name: "SearchCso",
        path: "/Search-Cso",
        component: SearchCso,
        meta: {
            title: "Search CSO",
        },
    },
    {
        name: "Tracking",
        path: "/Tracking",
        component: Tracking,
        meta: {
            title: "Tracking Case -  Hybrid System",
        },
    },

    {
        path: "/Project/Nonhp/DocNonHp/:maincase_id/:subcase_id",
        component: DocNonhp,
        meta: {
            title: "Doc Nonhp",
        },
    },
    {
        path: "/Return-Part/Doc/:type/:part_issue_id",
        component: DocLcdMb,
        meta: {
            title: "Doc LCD - MB",
        },
    },
    {
        name: "LuckyDay",
        path: "/Lucky-Day",
        component: LuckyDay,
        meta: {
            title: "ACACIA Lucky Day",
        },
    },
    {
        name: "Dashboards",
        path: "/Test/Dashboards",
        component: TestDashboards,
        meta: {
            title: "ACACIA - Dashboards",
        },
    },
    {
        path: "/HR/Employee",
        component: Employee,
        meta: {
            title: "Employee",
        },
    },
    {
        path: "/HR/Employee/Report-TimeAtt",
        component: TimeAttReport,
        meta: {
            title: "Employee - Report TimeAtt",
        },
    },

    {
        name: "Survey",
        path: "/Covid/Survey",
        component: SurveyCovid,
        meta: {
            title: "Covid - Survey",
        },
    },
    {
        name: "Survey-Report",
        path: "/Health-check/Report",
        component: SurveyReport,
        meta: {
            title: "Health check - Report",
        },
    },
    {
        path: "/Change-Request",
        component: Change,
        meta: {
            title: "Change Request Form",
        },
    },
    {
        path: "/PO-Pending",
        component: PoPending,
        meta: {
            title: "PO Pending",
        },
    },
    {
        path: "/ISMART",
        component: Ismart,
        meta: {
            title: "Ismart",
        },
    },
    {
        path: "/Print/Posnet",
        component: PrintPosnet,
        meta: {
            title: "Posnet Print Return ",
        },
    },
    {
        path: "/Project/Posnet/Case",
        component: PosnetData,
        meta: {
            title: "Posnet Data",
        }
    }
]

const router = new VueRouter({
    routes: routes,
    mode: "history",
})

router.beforeEach((to, from, next) => {
    // console.log(to.path)
    // console.log(from.path)
    next()
})

export default router